module.exports = __webpack_public_path__ + "img/goal_m02-2.5794812b.jpg";